export default {
  IMAGE: 'image',
  LINK: 'link',
  TEXT: 'text',
};
